import * as React from 'react'
import { useCallback } from 'react'

import Link from '@mui/material/Link'

import type { Params } from './typings'
import { ENTITY_TYPES } from '@sales-center/common'
import { useActivitySummaryContext } from '../../../context'
import { closeActivitySummaryActionCreator as close } from '../../../state'

export function RelatedToCell(props: Params<any>) {
  const {
    row: { id, entityId, entityType, relatedTo },
  } = props

  const [, dispatch] = useActivitySummaryContext()

  const onClick = useCallback(() => dispatch(close()), [dispatch])

  // SH-2338: an unattached activity has no record to link to. Early return sits
  // below the hooks so hook order stays stable across renders.
  if (entityId == null || entityType == null) return null

  const href = `#/${
    entityType === ENTITY_TYPES.Lead ? 'leads' : 'opportunities'
  }/${entityId}`

  return (
    <Link
      href={href}
      onClick={onClick}
      overflow="hidden"
      whiteSpace="nowrap"
      textOverflow="ellipsis"
      data-test-id={`activitySummary-relatedTo-${id}`}
    >
      {relatedTo}
    </Link>
  )
}
